import React from 'react';
import { FaEye, FaIntercom, FaRadiationAlt, FaReceipt } from 'react-icons/fa';
import CopyToClipboard from '../../../../../core/components/CopyToClipboard';
import { apiUrl, urlWebsite } from '../../../../../../../config';
import { useSocket } from '../../../../../../../hooks/Socket';
import { useModal } from '../../../../../../../hooks/Modal';
import Review from '../../../modules/Review';
import api from '../../../../../../../services/api';

interface ICreateModule {
  lineData: Record<string, any>;
}

export default function ReviewModule(): JSX.Element {

  const { addModal } = useModal();


  const openReviewComplete = async () => {

    const items = await api.get('/cientific-submissions', { params: { search: 'Submissão de trabalhos para o 2º Congresso Escolar Científico da UFCSPA', limitItems: 10000 } })

    const contentInfo: Array<JSX.Element> = [];
    items.data?.rows?.map(item => {

      contentInfo.push(<div style={{ padding: '30px 30px', breakAfter: 'always', border: '3px solid rgb(0,50,100)', borderRadius: '10px', marginBottom: '15px' }}>

        <div style={{ padding: '10px', width: '100%' }}>
          <p>Protocolo: {item?._id?.toString()}</p>
          <p>Professor: {item?.author}</p>
          <p>Instituição: {item?.author_institution}</p>
          <p>Autores: {item?.nested_co_authors}</p>
        </div>

        <div style={{ padding: '10px', marginTop: '10px', width: '100%' }}>
          <h2 style={{ color: 'rgb(0,50,100)', marginTop: '10px', }}>Título:</h2>
          <h2>{item.title}</h2>
          <h2 style={{ marginTop: '15px', color: 'rgb(0,50,100)' }}>Resumo:</h2>
          <p dangerouslySetInnerHTML={{ __html: item.short_description }} />

          <h2 style={{ marginTop: '15px', color: 'rgb(0,50,100)' }}>Palavras-chave:</h2>
          <p> {item?.nested_keywords}</p>
        </div>
      </div>)

      addModal({ title: '', content: <>{contentInfo}</>, theme: 'whiteModal' })


    })
  }

  const moduleCreate = (): JSX.Element => {

    return <>

      <div onClick={() => openReviewComplete()} title="Anais com autores" style={{ cursor: 'pointer', width: '30px', height: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%', border: '1px solid #333', margin: '5px' }}>
        <FaReceipt className="hover" style={{ cursor: 'pointer', color: 'rgb(0,100,150)' }} size={20} /></div>
    </>
  }



  return moduleCreate();
}
